import { useCallback, useEffect, useRef } from "react";
import { useConfig } from "../contexts/ConfigContext";

export function useParentBridge() {
  const { config } = useConfig();
  const allowedParentOrigin = config.REACT_APP_PARENT_ORIGIN || "https://app-phsoaccount-frontend-test-uks-001.azurewebsites.net";
  const handlersRef = useRef(new Set());

  useEffect(() => {
    const onMessage = (event) => {
      console.log("[CHILD] Message received:", event);
      if (event.source !== window.parent) return;
      if (event.origin !== allowedParentOrigin) return;

      const data = event.data;
      handlersRef.current.forEach((h) => h(data, event.origin, event.source));
    };

    window.addEventListener("message", onMessage);
    console.log("[CHILD] Sending HANDSHAKE to parent");
    window.parent.postMessage({ type: "HANDSHAKE" }, allowedParentOrigin);

    return () => window.removeEventListener("message", onMessage);
  }, [allowedParentOrigin]);

  const postToParent = useCallback(
    (msg) => {
      console.log("[CHILD] Posting message:", msg);
      window.parent.postMessage(msg, allowedParentOrigin);
    },
    [allowedParentOrigin]
  );

  const addHandler = useCallback((h) => {
    handlersRef.current.add(h);
    return () => handlersRef.current.delete(h);
  }, []);

  return { postToParent, addHandler };
}
